import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { services } from '../data/services';
import { legalDocuments } from '../data/legal';
import { company } from '../data/company';
export function Footer() {
  return <footer className="bg-navy-950 text-white/70" data-id="element-32" data-mp="36pftnw4hjt58">
      <div className="mx-auto max-w-shell px-6 py-16" data-id="element-33" data-mp="36q900vzj8gmu">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_0.8fr]" data-id="element-34" data-mp="3ufa5cad2jbnw">
          <div data-id="element-35" data-mp="3ud7ghtnnjokr">
            <Link to="/" className="inline-flex bg-white px-5 py-4" aria-label={`${company.name} — home`} data-id="element-36" data-mp="38qz78i6g9vx">
              <img src={company.logoUrl} alt={company.name} className="h-12 w-auto" data-id="element-37" data-mp="3le2jirrqo3ap" />
            </Link>
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed" data-id="element-38" data-mp="3qblyjtw9gk3p">
              Professional, discreet and dependable support for trusts, estates, personal
              affairs and the people who depend on them.
            </p>
            <ul className="mt-7 space-y-3 text-[15px]" data-id="element-39" data-mp="3l9ae7kt6385h">
              <li className="flex items-start gap-3" data-id="element-40" data-mp="3la272nvdqrs2">
                <PhoneIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-41" data-mp="3gaz2t5n84pl5" />
                <a href={company.phoneHref} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-42" data-mp="3v7gbfp413q40">
                  {company.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-43" data-mp="81fq3xcm4u4q">
                <MailIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-44" data-mp="34gwrh0rwr7l" />
                <a href={`mailto:${company.email}`} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-45" data-mp="hsk4ovydmcz1">
                  {company.email}
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-46" data-mp="qu1g410u9qhe">
                <MapPinIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-47" data-mp="ms6h536drp6s" />
                <span data-id="element-48" data-mp="tvcz5qtmo3em">
                  {company.addressLine1}
                  <br data-id="element-49" data-mp="twxtbfc15kby" />
                  {company.addressLine2}
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-50" data-mp="13tkc7yksq1bc">
            <h2 className="text-[11px] font-medium tracking-[0.2em] text-gold" data-id="element-51" data-mp="13t0twgr8haws">SERVICES</h2>
            <ul className="mt-5 space-y-2.5 text-[15px]" data-id="element-52" data-mp="18kiyrfwdnvn1">
              {services.map(service => <li key={service.slug} data-id="element-53" data-mp="1cmdvs879zmv0">
                  <Link to={`/services/${service.slug}`} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-54" data-mp="1clckq3q9f0da">
                    {service.title}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-55" data-mp="1rgsfkaynz0aq">
            <h2 className="text-[11px] font-medium tracking-[0.2em] text-gold" data-id="element-56" data-mp="3ob5681tmoz4l">COMPANY</h2>
            <ul className="mt-5 space-y-2.5 text-[15px]" data-id="element-57" data-mp="3odhrooylhrme">
              <li data-id="element-58" data-mp="3tb1bs5hz4ym9">
                <Link to="/" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-59" data-mp="3tccbnu8atm83">
                  Home
                </Link>
              </li>
              <li data-id="element-60" data-mp="25nc9m0q7603i">
                <Link to="/about" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-61" data-mp="25mu7wokrmto7">
                  About Us
                </Link>
              </li>
              <li data-id="element-62" data-mp="1wlvz7szdtxza">
                <Link to="/services" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-63" data-mp="2tdpu966gcwo2">
                  Fiduciary Services
                </Link>
              </li>
              <li data-id="element-64" data-mp="2kc0381ghfzqt">
                <Link to="/contact" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="2kbgkiij0d7bq">
                  Contact Us
                </Link>
              </li>
            </ul>
            <p className="mt-8 text-[13px] leading-relaxed text-white/50" data-id="element-66" data-mp="13zbc54pxw81j">
              Office hours: {company.hours}. Inquiries are returned within one business day.
            </p>
          </div>

          <div data-id="element-67" data-mp="2wm7opa68cu6z">
            <h2 className="text-[11px] font-medium tracking-[0.2em] text-gold" data-id="element-68" data-mp="2wmpoggs3pqjn">LEGAL</h2>
            <ul className="mt-5 space-y-2.5 text-[15px]" data-id="element-69" data-mp="2ivkwm0uz62jv">
              {legalDocuments.map(document => <li key={document.slug} data-id="element-70" data-mp="2ntcmkpc27elf">
                  <Link to={`/legal/${document.slug}`} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-71" data-mp="2ns1mp0lqiqzl">
                    {document.navLabel}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-7 text-[13px] text-white/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-72" data-mp="36kdljdd6ja4z">
          <p data-id="element-73" data-mp="1q52lcck3kuvd">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <p data-id="element-74" data-mp="1v6rzw26j3qo7">
            Information on this site is general in nature. See our{' '}
            <Link to="/legal/disclaimer" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-75" data-mp="1nkee4oaelpxe">
              Disclaimer
            </Link>
            .
          </p>
        </div>
      </div>
    </footer>;
}